import type { ComponentsToken } from 'antd/es/theme/context';

import { GreenColors, NeutralColors } from './colors';

export const ComponentsTokens: ComponentsToken = {
  Button: {
    primaryShadow: '0 0px 0 rgba(5, 145, 255, 0.1)',
    colorPrimary: GreenColors[60],
    colorPrimaryHover: GreenColors[50],
    colorPrimaryActive: GreenColors[70],
    textHoverBg: NeutralColors[10],
    colorBgTextActive: NeutralColors[20],
    borderRadius: 100,
    controlHeight: 40
  },
  Typography: {
    fontFamily: '"Noto Sans", sans-serif',
    fontSizeHeading1: 42,
    fontSizeHeading2: 30,
    fontSizeHeading3: 24,
    fontSizeHeading4: 20,
    fontSizeHeading5: 16,
    margin: 0,
    titleMarginBottom: '0',
    titleMarginTop: '0'
  },
  Divider: {
    colorSplit: 'rgb(223,226,231)',
    colorText: 'rgb(20,21,28)'
  },
  Anchor: {
    colorSplit: 'rgb(105,111,136)'
  },
  Breadcrumb: {
    colorBgTextHover: 'rgb(255,255,255)'
  },
  DatePicker: {
    paddingInline: 12,
    paddingBlock: 8
  },
  Form: {
    fontSize: 14,
    verticalLabelPadding: 2,
    itemMarginBottom: 12,
    controlHeight: 40
  },
  Avatar: {
    colorTextLightSolid: 'rgb(105,111,136)',
    colorTextPlaceholder: 'rgb(243,244,246)'
  },
  Segmented: {
    borderRadiusSM: 14,
    trackPadding: 2,
    controlPaddingHorizontal: 12,
    marginSM: 12,
    lineHeight: 1.5714285714285716,
    controlPaddingHorizontalSM: 10,
    controlHeightSM: 24
  },
  Table: {
    cellPaddingBlock: 10,
    cellPaddingBlockMD: 12,
    cellPaddingBlockSM: 10,
    cellPaddingInline: 16,
    cellPaddingInlineSM: 8,
    selectionColumnWidth: 32,
    lineHeight: 1.5714285714285716
  },
  Tooltip: {
    paddingSM: 12,
    lineHeight: 1.8,
    paddingXS: 12
  },
  Notification: {
    paddingLG: 16,
    paddingMD: 20,
    paddingContentHorizontalLG: 16
  },
  Modal: {
    paddingLG: 16
  },
  Alert: {
    withDescriptionPadding: '20px 12px'
  },
  Tag: {
    borderRadius: 4
  },
  Input: {
    controlHeight: 40,
    paddingBlock: 8,
    paddingInline: 12,
    borderRadius: 8,
    fontSizeIcon: 18
  },
  Select: {
    controlHeight: 40
  },
  InputNumber: {
    controlHeight: 40
  },
  Layout: {
    bodyBg: '#ffffff',
    siderBg: '#232630'
  },
  Menu: {
    itemColor: NeutralColors[40],
    itemSelectedColor: '#ffffff',
    itemSelectedBg: '#14151c'
  },
  Pagination: {
    controlHeight: 40
  },
  Steps: {
    colorPrimary: GreenColors[60],
    colorPrimaryHover: GreenColors[50],
    colorPrimaryBorder: GreenColors[60],
    colorText: GreenColors[60],
    finishIconBgColor: 'transparent',
    finishIconBorderColor: GreenColors[60],
    waitIconBgColor: 'transparent',
    waitIconBorderColor: NeutralColors[30],
    waitIconColor: NeutralColors[40]
  } as ComponentsToken['Steps']
};
